import { observer } from 'mobx-react-lite'
import Stack from '@mui/material/Stack'
import { PropsWithChildren } from 'react'
import { useThemeStore } from 'theme/ThemeStore'
import IconButton from '@mui/material/IconButton'
import Close from "@mui/icons-material/Close";
import Box from '@mui/material/Box'
import { AnnouncementEnum, AnnouncementTypeEnum } from '@gap/backend/app-services/announcement/enums/AnnouncementEnums'
import { useAnnouncementStore } from './AnnouncementStore'
import { themeConfig }from '@gap/shared/theme'

export type FrontEndAnnouncementEnum = 'proposalPreview' | 'windowTooSmall'

export type AllAnnouncementsEnum = AnnouncementEnum | FrontEndAnnouncementEnum
interface AnnouncementProps extends PropsWithChildren {
   type: AnnouncementTypeEnum
   announcementKey: AllAnnouncementsEnum
   dismissible?: boolean
}

export default observer(function Announcement(props: AnnouncementProps) {
   const themeStore = useThemeStore()
   const announcementStore = useAnnouncementStore()

   const getAnnouncementStyles = () => {
      switch (props.type) {
         case 'warning':
            return {
               backgroundColor: 'warning.main',
               color: 'warning.contrastText'
            }
         case 'error':
            return {
               backgroundColor: themeConfig.system.error[500],
               color: themeConfig.primary[900]
            }
         case 'info':
         default:
            return {
               backgroundColor: 'info.50',
               color: 'info.600'
            }
      }
   }

   return (
      <Stack
         direction='row'
         sx={{
            alignItems: 'center',
            px: 2,
            py: 1,
            boxShadow: 2,
            textAlign: 'center',
            justifyContent: 'center',
            position: 'relative',
            ...themeStore.theme.typography.body2,
            ...getAnnouncementStyles()
         }}
      >
         <Box display="flex" alignItems="center" flexGrow={0} mx="auto">
            {props.children}
         </Box>
         {props.dismissible &&
            <IconButton
               component="span"
               onClick={announcementStore.dismissAnnouncement(props.announcementKey)}
               sx={{ position: 'absolute', right: 16 }}
            >
               <Close fontSize='small' sx={{ color: 'info.800' }} />
            </IconButton>
         }
      </Stack>
   )
})
